<template>
  <b-modal
    :id="id"
    @ok="ok"
    @cancel="cancel"
    footer-class="justify-content-start"
    size="xl"
  >
    <template v-slot:modal-title>
      <slot name="modal-title" />
    </template>
    <b-container fluid>
      <b-row class="mb-3">
        <b-col cols="12">
          <slot name="modal-message" />
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="12">
          <p class="p-0 mb-1 font-weight-boldy float-left">
            Write a short reason for this action below:
          </p>
          <span class="p-0 mb-1 float-right"
            >{{ characterCount }}/{{ maximumReasonLength }}</span
          >
          <R-Textarea
            :maxLength="maximumReasonLength"
            :value="reasonPrompt"
            @onChange="reasonPrompt = $event.target.value"
          />
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:modal-footer="{ cancel, ok }">
      <R-Button :size="'small'" @onClick="cancel()">Close</R-Button>
      <R-Button :size="'small'" @onClick="ok()">Submit</R-Button>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: "ActionPromptModal",
  props: {
    id: {
      required: true,
    },
    handleSubmit: {
      required: true,
    },
    maximumReasonLength: {
      required: false,
      default: 255,
    },
  },
  data() {
    return {
      reasonPrompt: undefined,
    };
  },
  computed: {
    characterCount() {
      return this.reasonPrompt?.length ?? 0;
    },
  },
  methods: {
    ok() {
      this.handleSubmit(this.reasonPrompt);
      this._clean();
    },
    cancel() {
      this._clean();
    },
    _clean() {
      this.reasonPrompt = undefined;
    },
  },
};
</script>
